var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _ellipse2, _polygon, _polygon2, _polygon3, _rect, _polygon4, _polygon5, _polygon6, _polygon7, _rect2, _path25, _rect3, _path26, _circle, _circle2, _rect4, _rect5, _rect6, _path27, _polygon8, _rect7, _polygon9, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _circle3, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g, _path56, _path57, _path58, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _ellipse7, _path67, _polygon10, _polygon11, _polygon12, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlankCanvas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ffe6bee8-e793-4e33-a4ab-3e285c6a5a44",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 998.95,
    height: 833.99,
    viewBox: "0 0 998.95 833.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "8849c9b4-5ff8-40d0-8d32-f1e3227b06d9",
    x1: 499.14,
    y1: 857.42,
    x2: 499.14,
    y2: 171.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blank canvas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424.35,62.67c29.21-26,75.06-31.33,116.8-29.26,131.09,6.52,249.42,69.8,351.78,141.39,37.06,25.91,73.54,53.84,97.59,89.53,49,72.65,34.44,173.29-33.64,233.14-23.17,20.36-51.25,36-80.08,49.81-51.26,24.6-106.57,44.35-164.75,50-41.48,4-83.48.75-124.73-4.84C472.09,576.78,359,542.22,264.17,483.1,222.59,457.17,183.4,424.93,166.26,383S160.09,287.87,202.55,263c17.56-10.27,38.56-14.91,59.11-19.27,30.26-6.41,61-12.73,88.3-25.76,28.21-13.46,61.6-39.49,56-69.29C400,116.75,395.18,88.67,424.35,62.67Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M785.47,701.9s25.06-44.39,62.79-57.18a77.24,77.24,0,0,0,39.12-29.26,129.52,129.52,0,0,0,11.54-20.76",
    transform: "translate(-100.52 -33.01)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M922.66,586.49c-4.3,4.18-24.33,8.49-24.33,8.49s4.91-19.89,9.21-24.06a10.85,10.85,0,0,1,15.12,15.57Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M911.33,622.48c-5.88,1.17-25-6.09-25-6.09s14.94-14,20.81-15.2a10.85,10.85,0,0,1,4.23,21.29Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M870.08,661.42c-5.67-2-18.54-17.9-18.54-17.9s20-4.56,25.64-2.6a10.85,10.85,0,1,1-7.1,20.5Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M832.23,683.86c-5.91-1-21.29-14.51-21.29-14.51s18.91-7.88,24.82-6.9a10.85,10.85,0,1,1-3.53,21.41Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M869.59,600.85c0,6,10.84,23.37,10.84,23.37s10.86-17.37,10.86-23.36a10.85,10.85,0,1,0-21.7,0Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M825.66,627.65c1.8,5.72,17.34,19.06,17.34,19.06s5.16-19.83,3.37-25.55a10.85,10.85,0,0,0-20.71,6.49Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M786.54,659.55c.8,5.94,13.87,21.72,13.87,21.72s8.44-18.67,7.64-24.61a10.85,10.85,0,0,0-21.51,2.89Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M922.66,586.49c-4.3,4.18-24.33,8.49-24.33,8.49s4.91-19.89,9.21-24.06a10.85,10.85,0,0,1,15.12,15.57Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M911.33,622.48c-5.88,1.17-25-6.09-25-6.09s14.94-14,20.81-15.2a10.85,10.85,0,0,1,4.23,21.29Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M870.08,661.42c-5.67-2-18.54-17.9-18.54-17.9s20-4.56,25.64-2.6a10.85,10.85,0,1,1-7.1,20.5Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M832.23,683.86c-5.91-1-21.29-14.51-21.29-14.51s18.91-7.88,24.82-6.9a10.85,10.85,0,1,1-3.53,21.41Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M869.59,600.85c0,6,10.84,23.37,10.84,23.37s10.86-17.37,10.86-23.36a10.85,10.85,0,1,0-21.7,0Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.25
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M825.66,627.65c1.8,5.72,17.34,19.06,17.34,19.06s5.16-19.83,3.37-25.55a10.85,10.85,0,0,0-20.71,6.49Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M786.54,659.55c.8,5.94,13.87,21.72,13.87,21.72s8.44-18.67,7.64-24.61a10.85,10.85,0,0,0-21.51,2.89Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M786.91,701s4.92-50.74,34.24-77.72a77.24,77.24,0,0,0,23.9-42.61A129.14,129.14,0,0,0,847.19,557",
    transform: "translate(-100.52 -33.01)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M865.56,539.92c-2.24,5.56-18.8,17.62-18.8,17.62s-3.56-20.18-1.32-25.73a10.85,10.85,0,1,1,20.12,8.11Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M869.79,577.41c-4.9,3.45-25.36,4.57-25.36,4.57s8-18.87,12.87-22.32a10.85,10.85,0,0,1,12.49,17.75Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M847.86,629.73c-6,.5-24.2-8.86-24.2-8.86S840.07,608.61,846,608.1a10.85,10.85,0,0,1,1.82,21.63Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M822.35,665.58c-5.8,1.5-25.34-4.64-25.34-4.64s14.09-14.87,19.89-16.37a10.85,10.85,0,1,1,5.45,21Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M822.87,574.54c2.42,5.48,19.38,17,19.38,17s2.89-20.28.46-25.76a10.85,10.85,0,0,0-19.84,8.78Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M793.57,616.85c3.95,4.5,23.57,10.4,23.57,10.4s-3.31-20.22-7.27-24.72a10.85,10.85,0,1,0-16.3,14.32Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M770.73,661.87c3.14,5.11,21.48,14.23,21.48,14.23s.15-20.48-3-25.59a10.85,10.85,0,1,0-18.49,11.36Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.17,
    cy: 814.05,
    rx: 118.88,
    ry: 19.93,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.16,
    cy: 661.06,
    rx: 118.88,
    ry: 19.93,
    fill: "#6c63ff",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "616.05 398.03 615.94 401.92 609.18 640.44 597.82 640.44 603.39 401.92 603.5 397.43 616.05 398.03",
    fill: "#b77b7f"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "681.82 600.09 673.31 600.07 546.87 599.8 540.13 599.79 543.72 588.73 680.92 588.73 681.82 600.09",
    fill: "#dda2a6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "616.05 398.03 615.94 401.92 603.39 401.92 603.5 397.43 616.05 398.03",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 599.77,
    y: 392.2,
    width: 21.07,
    height: 7.93,
    fill: "#b77b7f"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "547.99 588.73 546.87 599.8 540.13 599.79 543.72 588.73 547.99 588.73",
    opacity: 0.1
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "566.14 392.05 565.79 395.49 537.74 672.13 524.89 671.52 554.45 395.49 554.78 392.35 566.14 392.05",
    fill: "#dda2a6"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "681.82 600.09 673.31 600.07 672.16 588.73 680.92 588.73 681.82 600.09",
    opacity: 0.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "695.27 671.52 682.41 672.13 654.37 395.49 654.02 392.05 665.37 392.35 665.7 395.49 695.27 671.52",
    fill: "#dda2a6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 466.6,
    y: 119.3,
    width: 283.36,
    height: 271.7,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M714.33,61.44v65.61H703.28V61.44a5.53,5.53,0,1,1,11.05,0Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#dda2a6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 602.75,
    y: 88.07,
    width: 11.06,
    height: 5.97,
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M718.67,125.56v21.66H699V125.56a2.68,2.68,0,0,1,2.69-2.69H716A2.69,2.69,0,0,1,718.67,125.56Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#dda2a6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 608.28,
    cy: 103.61,
    r: 4.18,
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 608.28,
    cy: 102.71,
    r: 4.18,
    fill: "#b77b7f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 598.42,
    y: 111.53,
    width: 19.73,
    height: 2.69,
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 590.35,
    y: 115.12,
    width: 35.87,
    height: 5.98,
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 590.35,
    y: 113.32,
    width: 35.87,
    height: 5.98,
    fill: "#dda2a6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M535.72,384H686.37a6.5,6.5,0,0,1,6.5,6.5v1.42a0,0,0,0,1,0,0H529.22a0,0,0,0,1,0,0v-1.42A6.5,6.5,0,0,1,535.72,384Z",
    opacity: 0.1
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "554.78 392.35 566.14 392.05 565.79 395.49 554.45 395.49 554.78 392.35",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 599.77,
    y: 392.2,
    width: 21.07,
    height: 3.29,
    opacity: 0.1
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "665.7 395.49 654.37 395.49 654.02 392.05 665.37 392.35 665.7 395.49",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M535.72,385.77H686.37a6.5,6.5,0,0,1,6.5,6.5v1.42a0,0,0,0,1,0,0H529.22a0,0,0,0,1,0,0v-1.42A6.5,6.5,0,0,1,535.72,385.77Z",
    fill: "#dda2a6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M603.21,292.64c-2.27-1.2-27-19.88-27-19.88l-39.91-25.31s-.21-.6-.59-1.63c10.95-12.43,8.56-30.47-2.58-43.15-13.5-15.38-74.5-48.49-92.88-20.17-2.57,4-2.66,8.54-3.33,12.94-1.57,10.27-6.63,20.22-14.57,28.6-6.12,6.47-14.15,12.43-17.67,19.75,0-.09-.07-.18-.1-.28a18.36,18.36,0,0,0-1.83,5C401,257.44,407,266,410.19,274.69a47.5,47.5,0,0,1,2.32,9.08c.08-.62.15-1.23.22-1.85a58.06,58.06,0,0,1,.79,13.36c-22.15,4.51-22.16,42.4-22.16,42.4s-2.73,15.06-2.27,20.49.45,17.17.45,20-2.73,20.48-3,22.6a.51.51,0,0,1,0,.09c-.4,2.32-4.55,13.5,5.48,16,.7.18,1.44.33,2.21.47.43,9.05,1.21,28,.52,32.22,0,0,3.65,25.46,6.68,31.93a73.44,73.44,0,0,0,6.7,10.82,11.92,11.92,0,0,1-1.54,4.39c-1.55,2.23-.75,4.06,1.84,4.85-.09.77-.19,1.64-.3,2.62-1.11,9.82-2.77,29.34.05,39.23,3.87,13.56,4.1,18.08,4.1,18.08s0,4.06,1.6,6.32,4.55,23.28,4.55,26.67,7.74,33.89,5.46,41.12-.45,17.4-.45,17.4-1.37,17.85-3,21.69-2.28,65.75.22,81.79,4.1,29.37,4.1,29.37-1.59,14.69-.23,16.72,3.87,14.24,2.05,14.91-2.73,5.65-2.73,5.65a50.39,50.39,0,0,0,3.11,4.23,17,17,0,0,1-2.05-.87c.72,1,1.8,2.42,3.13,4l-1.25,16.25a2.72,2.72,0,0,0,2,2.85,22.87,22.87,0,0,0,22.62-6.36c11.38-11.52,15.25-9.94,17.3-16.94.22-.75.41-1.49.57-2.19,1.47-6.24-5.18-10.88-10.47-8.22.73-4.94,1.3-10.55.75-13.72-1.14-6.55-.91-23.72-.91-23.72l-1.59-82.25s2.95-16.27,6.37-22.59,3-28.47,3-28.47l3.87-72.76,3.64-35.47s3.64-12.2,8.19,1.36c0,0-2.5,27.33-1.36,33.89s2.73,38.41,1.59,45.41-6.14,45.42-3,55.13S486,694.15,485.3,698s-3,87.21-3,87.21,6.15,16,1.6,21.24-.23,26-.23,26,.55.39,1.49.93l-.13,1.73-1.43,18.69a2.74,2.74,0,0,0,2,2.86,22.86,22.86,0,0,0,22.62-6.36c11.38-11.53,15.25-9.94,17.3-16.95.22-.75.41-1.48.58-2.19,1.6-6.81-6.5-11.75-11.92-7.3l-.27.23a9.41,9.41,0,0,1-.89.67,4.3,4.3,0,0,1-.45.29c1.14-5.16,2.8-14,2-18.14-1.14-6.1,1.13-24.62,1.13-24.62s6.6-22.15,6.83-31l1.82-70.49s-.22-28.7.69-35.7,8.19-67.56,15.47-85.64c5.59-13.84,8.09-49.16,6.61-67.07-.08-.88-.16-1.73-.26-2.52,8.93-6.59,9.82-17.55,9.82-17.55s-8.2-15.66-16.09-22.29S531,432,531.28,427.15a11.88,11.88,0,0,0-2.73-8.13s-3.64-11.75-6.07-12.95a1.9,1.9,0,0,1-.53-.4c-1.65-1.77-.38-6.83-.38-6.83l0-.16c.29-1.17,2-8.75,1.49-10.69-.61-2.1.3-12.05.3-12.05s5.77-17.17,4.86-30.73,11.84-12.35,11.84-12.35l39.37-.41,4.48,0a31.53,31.53,0,0,0,4.31-4.46c7.5-.89,22.67-3.72,24.37-12C614.9,305,605.49,293.85,603.21,292.64ZM420.81,418l.27-6.89c.93.8,1.55,1.31,1.55,1.31a10.78,10.78,0,0,1,.07,5.52,5.89,5.89,0,0,1-3.41,3.82,4.14,4.14,0,0,0-.55.29l-.38-3.89Zm142.8-121c-1.67-.75-7.29-.6-10.18-.6s-7.58-2.41-7.58-2.41c-1-1.95-6.53-3.11-11.45-3.77-3.74-9.22-9-18.21-9.71-27.82,0-.35,0-.7-.05-1.05l.57,1s22.92,14.62,25.5,19c2,3.34,11.63,10.8,16.09,14.14a4.59,4.59,0,0,1-2.45,1.64A1.35,1.35,0,0,1,563.61,297Z",
    transform: "translate(-100.52 -33.01)",
    fill: "url(#8849c9b4-5ff8-40d0-8d32-f1e3227b06d9)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M525.76,831.22c-.17.7-.35,1.43-.57,2.17-2,7-5.83,5.38-17,16.81a22.38,22.38,0,0,1-22.27,6.32,2.7,2.7,0,0,1-2-2.84l1.41-18.54.67-8.92s17.84,5,26.92-1.35a10.77,10.77,0,0,0,.88-.67A2.75,2.75,0,0,0,514,824,7.29,7.29,0,0,1,525.76,831.22Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#67647e"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M469.76,824.22c-.17.7-.35,1.43-.57,2.17-2,7-5.83,5.38-17,16.81a22.38,22.38,0,0,1-22.27,6.32,2.7,2.7,0,0,1-2-2.84l1.41-18.54.67-8.92s17.84,5,26.92-1.35a10.77,10.77,0,0,0,.88-.67A2.75,2.75,0,0,0,458,817,7.29,7.29,0,0,1,469.76,824.22Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#67647e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M451.33,827l.72,9.64c-10.24,10.23-22.43-5-26-10C435.44,831.48,451.33,827,451.33,827Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M511.52,830.92l1.34-.89c-9.35,14.22-23.24,7.66-27.57,5.11l.67-8.92s17.84,5,26.92-1.35C512.17,828.35,511.52,830.92,511.52,830.92Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M540,561.69c-7.18,17.93-14.35,78-15.25,85s-.67,35.42-.67,35.42L522.28,752c-.23,8.75-6.73,30.72-6.73,30.72s-2.24,18.38-1.12,24.43-2.91,22-2.91,22l1.34-.9c-11.21,17-28.92,4.26-28.92,4.26s-4.26-20.62.23-25.78-1.57-21.07-1.57-21.07,2.24-82.72,2.91-86.53-2.69-15.47-5.83-25.11,1.8-47.75,2.92-54.7-.45-38.56-1.57-45.06,1.34-33.63,1.34-33.63c-4.48-13.45-8.07-1.34-8.07-1.34l-3.59,35.19-3.81,72.19s.45,22-2.91,28.25-6.28,22.41-6.28,22.41l1.57,81.61s-.22,17,.9,23.53-2.47,23.32-2.47,23.32C445.16,855.36,425,823.3,425,823.3s.9-4.93,2.69-5.6-.67-12.78-2-14.8.22-16.59.22-16.59-1.57-13.22-4-29.14-1.79-77.34-.22-81.15,2.91-21.52,2.91-21.52-1.79-10.09.45-17.27-5.38-37.43-5.38-40.8-2.91-24.21-4.48-26.45-1.57-6.28-1.57-6.28-.22-4.48-4-17.93c-2.78-9.82-1.14-29.18-.05-38.93.39-3.61.73-5.91.73-5.91S538.87,480.08,544,484.79c1.2,1.11,2,4.92,2.47,10.35C548,512.9,545.48,548,540,561.69Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#444053"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M491.34,662.49c.6,0,14.8,1.2,20,.15S491.34,662.49,491.34,662.49Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M492.39,670.86S512,674.3,513,672.51,492.39,670.86,492.39,670.86Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M432.46,667.27s10.16.45,15.69,3S432.46,667.27,432.46,667.27Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M395.54,415.9s1.64,31.23.75,36.76c0,0,3.58,25.26,6.57,31.68s9.42,14.5,9.42,14.5l8.82-62L419,415.6Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#efb7b9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 387.68,
    cy: 206.09,
    r: 34.52,
    fill: "#efb7b9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M470.27,255.23s-10.76,21.08-21.52,30.94,64.56,21.07,66.35,21.07S501.65,262.41,504.34,257,470.27,255.23,470.27,255.23Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#efb7b9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M546.49,495.14a22.43,22.43,0,0,1-5.54,3.1c-13.74,5.38-28.69,12.85-38.85,9.87s-31.68,0-31.68,0-43.35-3.59-52-1.5c-3.94.95-7,.91-9,.23.39-3.61.73-5.91.73-5.91S538.87,480.08,544,484.79C545.22,485.9,546,489.71,546.49,495.14Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M555.9,475.22s-1.19,14.95-14.95,20.33-28.69,12.85-38.85,9.87-31.68,0-31.68,0-43.35-3.59-52-1.5-13.16-.59-10.47-4.48,2.4-16.74,2.4-22.12-3-27.2-.31-31.09S415.12,427.4,420.5,425a5.86,5.86,0,0,0,3.36-3.79,10.84,10.84,0,0,0-.07-5.47s-.91-.75-2.16-1.86c-3.17-2.83-8.53-8.08-6.81-9.8,2.39-2.4,0-17.94,0-17.94s-5.68-11.95-3.58-16.43S393,341.61,393,341.61s0-40.64,24.51-42.44c0,0,17.34.6,19.43-7.17s15.84-12.26,15.84-12.26l31.39,6.88s27.79,6,32.88,2.39,9,4.78,9,4.78,17.33.9,19.12,4.49-5.67,38.55-5.67,38.55-12.56-1.19-11.66,12.26S523,379.58,523,379.58s-.9,9.86-.3,11.95c.56,1.93-1.18,9.45-1.46,10.61l0,.15s-1.25,5,.37,6.78a2,2,0,0,0,.52.4c2.4,1.19,6,12.85,6,12.85a11.83,11.83,0,0,1,2.69,8.07c-.29,4.79,1.5,16.14,9.27,22.72S555.9,475.22,555.9,475.22Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#a36468"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M422.59,406l0,1.27-.54,14s-18.39,1.49-28.4-1-5.8-13.6-5.4-15.9a.37.37,0,0,0,0-.09c.29-2.1,3-19.58,3-22.42s0-14.5-.45-19.88S393,341.61,393,341.61l1.94-2.38L416,347.3Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#a36468"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M422.54,407.3l-.54,14s-18.39,1.49-28.4-1-5.8-13.6-5.4-15.9Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M423.86,421.22a10.84,10.84,0,0,0-.07-5.47s-.91-.75-2.16-1.86c15.83-2.21,78.52-10.81,99.63-11.75l0,.15s-1.25,5,.37,6.78Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M523.62,432s3.89,22-10.61,29.74C513,461.78,521.23,450.87,523.62,432Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M428.72,462.37s35-6,41.85-1.34S428.72,462.37,428.72,462.37Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M511.52,326.22s-5.38,22.12-1.35,27.2S511.52,326.22,511.52,326.22Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M410.19,308.14s4.93,8.22,1.94,16.74S410.19,308.14,410.19,308.14Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M400,380.18s6.28,3.73,4.19,9.56S400,380.18,400,380.18Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M399.43,363.14s5.82,3.14,6.57,7.77S399.43,363.14,399.43,363.14Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M485.81,541.88s36.62,3.74,43.94-4.93C529.75,537,496.72,543.53,485.81,541.88Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M422.59,539.79s39.31,9.27,47.08,1.94C469.67,541.73,435.89,544.27,422.59,539.79Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M488.65,554s16.44,0,24.06.45S488.65,554,488.65,554Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M425.28,561s8.07,9.12,17.19,7.48S425.28,561,425.28,561Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M441.13,187.65c-2.53,3.93-2.62,8.48-3.28,12.84-1.54,10.19-6.53,20.06-14.34,28.38-7.17,7.62-17,14.53-18.86,23.84-1.76,8.84,4.21,17.35,7.34,26,8.25,22.69-3.27,46.49-6.63,69.91-.93,6.47.19,14.74,8.16,16.89,2.49.68,5.34.59,7.58,1.67,3,1.44,3.92,4.43,4.47,7.12a108.82,108.82,0,0,1,2.06,29.28c-.36,5.5-.76,11.83,4.44,15.61,2.36,1.73,5.54,2.61,8.61,3.44,8.19,2.21,18.78,4,24.3-1.19,2.32-2.17,3.19-5.23,6.08-6.95,4.33-2.57,10.47-.83,15.92-.56,11.19.56,21.47-6,25.88-13.91s4-17,2.4-25.53-4.46-17-4.66-25.66c-.07-3,.2-6.05,1.92-8.71,3.33-5.15,11.08-7.49,16.38-11.54,9.93-7.6,9.9-20.05,6.29-30.47S525.1,277.7,524.3,266.93a11.87,11.87,0,0,1,1.47-7.53c1.42-2.19,3.9-3.83,6-5.64,14.49-12.24,12.78-32.34.8-46.1C519.31,192.41,459.23,159.56,441.13,187.65Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#e3787d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.83,288.13c1.13-9.09.92-18.1-2.29-26.95-1.58-4.34-3.87-8.65-5.54-13a18.76,18.76,0,0,0-1.8,5c-1.76,8.84,4.21,17.35,7.34,26A47.28,47.28,0,0,1,413.83,288.13Z",
    transform: "translate(-100.52 -33.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.18,386.05a109.22,109.22,0,0,0-2.05-29.28c-.56-2.69-1.48-5.67-4.48-7.11-2.24-1.08-5.09-1-7.58-1.67a10.33,10.33,0,0,1-7-5.78c-.46,2.28-.86,4.55-1.19,6.83-.93,6.47.19,14.74,8.16,16.89,2.49.67,5.34.58,7.58,1.66,3,1.44,3.92,4.43,4.48,7.12a110.81,110.81,0,0,1,1.92,13.52C427.09,387.49,427.13,386.77,427.18,386.05Z",
    transform: "translate(-100.52 -33.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.42,382.5c-4.42,7.94-14.7,14.47-25.89,13.91-5.45-.28-11.59-2-15.91.56-2.89,1.71-3.77,4.78-6.09,6.95-5.52,5.15-16.11,3.4-24.3,1.19-3.07-.84-6.24-1.71-8.61-3.44a10.8,10.8,0,0,1-4.25-6.9c.06,3.07,0,6.15-.19,9.22-.36,5.5-.76,11.83,4.44,15.62,2.37,1.72,5.54,2.6,8.61,3.43,8.19,2.21,18.78,4,24.3-1.19,2.32-2.17,3.2-5.23,6.09-7,4.32-2.57,10.46-.83,15.91-.56,11.19.56,21.47-6,25.89-13.91,4.24-7.64,4.05-16.28,2.57-24.53A26.87,26.87,0,0,1,512.42,382.5Z",
    transform: "translate(-100.52 -33.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.36,236.28c-2.14,1.8-4.62,3.45-6,5.64a11.87,11.87,0,0,0-1.47,7.53,40.06,40.06,0,0,0,2.06,9.6,39.94,39.94,0,0,1,5.45-4.84c9.8-8.27,12.18-20.14,9-31.22A28.54,28.54,0,0,1,531.36,236.28Z",
    transform: "translate(-100.52 -33.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.45,311.05c-5.29,4.05-13.05,6.4-16.37,11.55-1.73,2.66-2,5.73-1.93,8.7a60.08,60.08,0,0,0,1.28,10.4,9.62,9.62,0,0,1,.65-1.17c3.32-5.15,11.08-7.49,16.37-11.54,9.07-6.94,9.83-17.92,7.15-27.71A20.76,20.76,0,0,1,528.45,311.05Z",
    transform: "translate(-100.52 -33.01)"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M582.8,332.35s25.86-1.34,28.1-12.25-7-22-9.26-23.17S575,277.2,575,277.2l-39.3-25.1s-18.83-54-23-33.33,12.11,48.12,12.11,48.12,22.56,14.5,25.1,18.83S568,301.41,568,301.41Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#efb7b9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M596.7,314.71c-6.12,15.55-14.05,21.68-14.05,21.68l-4.41,0-38.77.4L535,324.58l6.28-26.46,3.88.16s4.64,2.39,7.47,2.39,8.38-.15,10,.59a1.23,1.23,0,0,0,.73.11c1.47-.15,3-2.35,3-2.35S602.83,299.17,596.7,314.71Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#a36468"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M596.7,314.71c-6.12,15.55-14.05,21.68-14.05,21.68l-4.41,0c2.3-6.16,7.15-18.8,9-21.72,1.81-2.76-14.43-9.63-23.93-13.34,1.47-.15,3-2.35,3-2.35S602.83,299.17,596.7,314.71Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.82,
    cy: 763.14,
    rx: 44.18,
    ry: 8.64,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 827.28,
    cy: 706.15,
    rx: 32.18,
    ry: 6.29,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 966.77,
    cy: 731.64,
    rx: 32.18,
    ry: 6.29,
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 750.78,
    cy: 784.14,
    rx: 32.18,
    ry: 6.29,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M233.09,556.31s7.24,9.47-3.34,23.75S210.46,606.4,214,615.31c0,0,15.95-26.53,28.94-26.9S247.38,572.27,233.09,556.31Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M233.09,556.31a11.79,11.79,0,0,1,1.48,3c12.67,14.89,19.42,28.78,7.24,29.13-11.34.32-24.95,20.61-28.21,25.73a9.44,9.44,0,0,0,.39,1.17s15.95-26.53,28.94-26.9S247.38,572.27,233.09,556.31Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M246.54,568.37c0,3.33-.37,6-.83,6s-.84-2.7-.84-6,.47-1.76.93-1.76S246.54,565,246.54,568.37Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#ffd037"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M251.16,572.35c-2.92,1.59-5.47,2.56-5.69,2.15s2-2,4.89-3.62,1.77-.43,2,0S254.08,570.75,251.16,572.35Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#ffd037"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M194.88,556.31s-7.24,9.47,3.34,23.75S217.51,606.4,214,615.31c0,0-16-26.53-29-26.9S180.59,572.27,194.88,556.31Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#6c63ff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M194.88,556.31a11.79,11.79,0,0,0-1.48,3c-12.67,14.89-19.42,28.78-7.24,29.13,11.34.32,25,20.61,28.21,25.73a11.41,11.41,0,0,1-.38,1.17s-16-26.53-29-26.9S180.59,572.27,194.88,556.31Z",
    transform: "translate(-100.52 -33.01)",
    opacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M181.43,568.37c0,3.33.37,6,.83,6s.84-2.7.84-6-.47-1.76-.93-1.76S181.43,565,181.43,568.37Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#ffd037"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M176.81,572.35c2.93,1.59,5.47,2.56,5.7,2.15s-2-2-4.9-3.62-1.77-.43-2,0S173.89,570.75,176.81,572.35Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#ffd037"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.46,
    cy: 643.07,
    rx: 75.65,
    ry: 11.61,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M252.92,602.56l-.36,3-.51,4.17-.21,1.74-.51,4.18-.22,1.74-.51,4.17L244.82,669c-.52,4.24-7.44,7.54-15.8,7.54H199c-8.36,0-15.27-3.3-15.79-7.54l-5.79-47.45-.51-4.17-.21-1.74-.52-4.18-.21-1.74-.51-4.17-.36-3c-.29-2.4,3.45-4.42,8.18-4.42h61.52C249.47,598.14,253.22,600.16,252.92,602.56Z",
    transform: "translate(-100.52 -33.01)",
    fill: "#65617d"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.03 572.5 151.53 576.68 75.39 576.68 74.89 572.5 152.03 572.5",
    fill: "#9d9cb5"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "151.31 578.42 150.81 582.59 76.12 582.59 75.61 578.42 151.31 578.42",
    fill: "#9d9cb5"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.59 584.33 150.08 588.5 76.84 588.5 76.33 584.33 150.59 584.33",
    fill: "#9d9cb5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.99,
    cy: 124.52,
    r: 31.5,
    fill: "#6c63ff",
    opacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.99,
    cy: 49.52,
    r: 19.5,
    fill: "#6c63ff",
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 93.02,
    r: 12,
    fill: "#6c63ff",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankCanvas);
export default __webpack_public_path__ + "static/media/blank_canvas.41af02505597f44482b9007e7abe5698.svg";
export { ForwardRef as ReactComponent };